import { ContentDownload } from '@fs/zion-icon'
import { Button } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { toLocaleString } from '../../../util/DateUtil'
import { downloadFile } from '../../../util/FileDownloadUtil'
import useNotifications from '../../../hooks/useNotifications'

export default function DownloadGroupMembersButton({ members }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const downloadMembers = async () => {
    try {
      const stringList = getStringList()
      const matchTermsString = stringList.join('\n')
      downloadFile(matchTermsString, `${members[0].groupId}-members.csv`)
      ok(t('action.downloadCompleted', 'Download Completed'))
    } catch (err) {
      error(t('action.downloadFailed', 'Download Failed'))
    }
  }

  function getStringList() {
    const stringList = []
    stringList.push([
      `${t('contactName', 'Contact Name')}, ${t('status.label', 'Status')}, ${t(
        'groups.members.joinDate',
        'Join Date'
      )}, ${t('groups.groupId', 'Group ID')}, ${t('groups.members.memberCisId', 'Member CIS ID')}, ${t(
        'groups.members.notifyOnJoin',
        'Notify On Join'
      )}, ${t('groups.members.portraitUrl', 'Portrait URL')}`,
    ])
    members.forEach((member) => {
      const data = `${member.contactName},${member.status},${toLocaleString(new Date(member.createDate), false)},${
        member.groupId
      },${member.memberCisId},${member.notifyOnJoin},${member.portraitUrl}`
      stringList.push(data)
    })
    return stringList
  }

  return (
    <Button onClick={downloadMembers} Icon={ContentDownload} emphasis="medium">
      {t('action.download', 'Download')}
    </Button>
  )
}
